import { useNavigate } from 'react-router'

import BackLink from '@/elements/BackLink'
import Flex from '@/elements/Flex'
import Text from '@/elements/Text'
import Tabs from '@/components/Tabs'
import OrganizationMemberTabs from '@/router/tabsSystems/organizationMemberTabs'

function MemberSettings() {
  const navigate = useNavigate()

  return (
    <Flex component='section' gap={4} grow>
      <BackLink onBackOverride={() => navigate('/organization/members')} />
      <Text variant='h1'>Member Settings</Text>
      <Tabs tabs={OrganizationMemberTabs} />
    </Flex>
  )
}

export default MemberSettings
